import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { hasDirectPermissions } from '@/lib/permissions';
import { ShieldOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AccessDenied = () => (
  <div className="min-h-screen w-full flex items-center justify-center bg-slate-50 p-6">
    <div className="text-center max-w-md">
      <div className="w-16 h-16 rounded-2xl bg-red-100 mx-auto mb-4 flex items-center justify-center">
        <ShieldOff className="text-red-600" size={32} />
      </div>
      <h1 className="text-2xl font-secondary font-bold text-slate-900">Acesso Negado</h1>
      <p className="text-sm text-slate-600 mt-2">
        Não tem permissões para aceder a esta página. Contacte o administrador da sua organização.
      </p>
      <Button className="mt-6" onClick={() => window.history.back()}>Voltar</Button>
    </div>
  </div>
);

export const ProtectedRoute = ({ children, permissions }) => {
  const { user, ready } = useAuth();
  const location = useLocation();
  const isFirstLoginFlow = location.pathname === '/first-login' || location.pathname.startsWith('/email/verify/');
  if (!ready) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  // Se o utilizador foi convidado (ou teve password resetado), tem de definir nova antes
  // de aceder ao resto da app. /first-login é a única rota autorizada até isso acontecer.
  if ((user.mustChangePassword || !user.emailVerified) && !isFirstLoginFlow) {
    return <Navigate to="/first-login" replace />;
  }
  if (!hasDirectPermissions(user.permissions, permissions)) return <AccessDenied />;
  return children;
};
